import { IContainer, injectContainer } from './container';

export interface IAsset {
    path: string;
}

export interface IImageAsset extends IAsset {
    width: number;
    height: number;
}

export interface IImageAssetMap {
    Flag: {
        AD: IImageAsset;
        AR: IImageAsset;
        BE: IImageAsset;
        BG: IImageAsset;
        BP: IImageAsset;
        BSL: IImageAsset;
        CS: IImageAsset;
        DE: IImageAsset;
        EN: IImageAsset;
        ES: IImageAsset;
        FI: IImageAsset;
        FR: IImageAsset;
        GD: IImageAsset;
        GL: IImageAsset;
        GR: IImageAsset;
        HU: IImageAsset;
        IS: IImageAsset;
        IT: IImageAsset;
        JA: IImageAsset;
        KO: IImageAsset;
        LT: IImageAsset;
        NL: IImageAsset;
        NO: IImageAsset;
        PL: IImageAsset;
        PT: IImageAsset;
        RO: IImageAsset;
        RU: IImageAsset;
        SE: IImageAsset;
        SH: IImageAsset;
        ZH: IImageAsset;
    };
    AppIcon: {
        167: IImageAsset;
        180: IImageAsset;
        192: IImageAsset;
        512: IImageAsset;
        64: IImageAsset;
        favico: IImageAsset;
    };
    Splash: {
        '1024x1024': IImageAsset;
        '1125x2436': IImageAsset;
        '1136x640': IImageAsset;
        '1200x627': IImageAsset;
        '1242x2148': IImageAsset;
        '1294x750': IImageAsset;
        '1536x2048': IImageAsset;
        '1668x2224': IImageAsset;
        '2048x1536': IImageAsset;
        '2048x2732': IImageAsset;
        '2148x1242': IImageAsset;
        '2224x1668': IImageAsset;
        '2436x1125': IImageAsset;
        '2732x2048': IImageAsset;
        '640x1136': IImageAsset;
        '750x1294': IImageAsset;
    };
    Misc: {
        Alpha: IImageAsset;
        Alpha_Debug: IImageAsset;
    };
}

export interface IAssetMap {
    Image: IImageAssetMap;
}

export interface IAssetFetcher {
    imageAsset<K extends keyof IImageAssetMap, V extends keyof IImageAssetMap[K]>(
        group: K,
        name: V,
    ): IImageAssetMap[K][V];
    imageAssetGroup<K extends keyof IImageAssetMap>(group: K): Array<IImageAsset>;
    imageAssetGroupClosestMatch<K extends keyof IImageAssetMap>(
        group: K,
        targetWidth: number,
        targetHeight: number,
    ): IImageAsset;
}

const TYPES = {
    IAssetFetcher: Symbol.for('IAssetFetcher'),
};

export function injectAssetFetcher(container: IContainer = injectContainer()): IAssetFetcher {
    return container.get<IAssetFetcher>(TYPES.IAssetFetcher);
}

export function bindAssetFetcher(val: IAssetFetcher, container: IContainer = injectContainer()) {
    return container.bind<IAssetFetcher>(TYPES.IAssetFetcher, val);
}
